/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { connect } from "react-redux";
import PerfectScrollbar from 'react-perfect-scrollbar';
import Grid from "@material-ui/core/es/Grid";
import Typography from "@material-ui/core/es/Typography";
import { version } from '../../../../../../package.json';
import {
  Drawer,
  Hidden,
  List
} from '@material-ui/core';
import NavItem from './NavItem';
import * as Icon from 'react-feather';

let navConfig = [
  {
    items: [
      {
        title: 'Signature Editor',
        icon: Icon.Activity,
        href: '/signature'
      },
      // {
      //   title: 'Avatar',
      //   icon: Icon.Image,
      //   href: '/avatar'
      // },
      // {
      //   title: 'Profile',
      //   icon: Icon.UserCheck,
      //   href: '/profile'
      // },
      // {
      //   title: 'Welcome',
      //   icon: Icon.Home,
      //   href: '/'
      // },
      {
        title: 'Devices',
        icon: Icon.Monitor,
        href: '/devices'
      },
      // {
      //   title: 'Show Account',
      //   icon: Icon.User,
      //   href: '/account'
      // },
      {
        title: 'Shared Emails',
        icon: Icon.Mail,
        href: '/shared-emails'
      },
      // {
      //   title: 'Delete Account',
      //   icon: Icon.Activity,
      //   href: '/delete-account'
      // },
      {
        title: 'Subscription',
        icon: Icon.CreditCard,
        href: '/subscription'
      },
      // {
      //   title: 'Billing',
      //   icon: Icon.DollarSign,
      //   href: '/billing'
      // },
      {
        title: 'Settings',
        icon: Icon.Settings,
        href: '/settings'
      }     
    ]
  }
];

function renderNavItems({ items, onMobileClose, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, onMobileClose, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth = 0,
  onMobileClose
}) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        onMobileClose={onMobileClose}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>

    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        onMobileClose={onMobileClose}
        info={item.info}
        title={item.title}
      />
    );
  }

  return acc;
}

// const removeUnsupportedTabs = (items, env) => {
//   return items.map(tab => env === 'production' && tab.href === '/profile' ? null : tab).filter(Boolean);
// }

const removeUnsupportedTabs = (items, env, brandName) => {
  return items
    .map(tab => {
      console.log(tab.href, tab.title, env, brandName); // Add this line for debugging
      if (env === 'production' && ((tab.href === '/signature' || tab.href === '/subscription') && brandName === 'TypeApp' || tab.href === '/profile')) {
        return null;
      }
      return tab;
    })
    .filter(Boolean);
};

class NavBar extends Component {
  constructor(props) {
    super(props);
  }

  render(){
    const { isMobileNavOpen, onMobileClose, brand, user, setMobileNavClose, app } = this.props;

    console.log(brand, "Brand")
    // Remove signature tab if env eq production
    navConfig[0].items = removeUnsupportedTabs(navConfig[0].items, app.env, brand.name);
    const content = (onMobileClose) => {
      return <div style={{height:"100%", display:"flex", flexDirection:"column", width: '256px'}}>
        <PerfectScrollbar options={{ suppressScrollX: true }}>
          <div>
            {navConfig.map((config, i) => (
                <List key={i}>
                  {renderNavItems({ items: config.items, pathname: location.pathname, onMobileClose: onMobileClose })}
                </List>
            ))}
          </div>
          <div>
          </div>
        </PerfectScrollbar>
        <div id='version' style={{position: 'absolute', bottom: '10px', width: '100%'}}>
          <p style={{fontSize: '13px', textAlign: 'center'}}>{version}</p>
        </div>
      </div>
    };

    return (
      <div>
        <Hidden lgUp>
          <Drawer style={{width: '256px', height: 'calc(100% - 64px)', top: '64px', zIndex: '1200'}}
            anchor="left"
            onClose={onMobileClose}
            open={isMobileNavOpen}
            className="drawer"
            variant="temporary">
            {content(setMobileNavClose)}
          </Drawer>
        </Hidden>
        <Hidden mdDown>
          <Drawer 
          anchor="left" 
          className="drawer-reg" 
          style={{width: '256px', height: 'calc(100% - 64px)', top: '64px', zIndex: '1200'}} 
          open 
          variant="persistent">
            {content(setMobileNavClose)}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

const mapStateToProps = ({ app, brand }) => ({ app, brand });

export default connect(mapStateToProps, {})(NavBar);



// WEBPACK FOOTER //
// ./src/containers/app/components/DashboardLayout/NavBar/NavBar.js